<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="班级升班" v-model="hideShow" width="500px" persistent>
			<v-card>
				<v-card-title>
					<span>班级升班</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense v-if="classViewModel">
						<v-col cols="12">
							<v-text-field label="原课程名称" v-model="classViewModel.courseName" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-select :items="selectCourseList" v-model="update.courseId" item-text="courseName"
								item-value="id" return-object label="新课程名称" dense outlined @change="courseChanged"></v-select>
						</v-col>
						<v-col cols="6" v-if="selectedCourse">
							<v-text-field label="新课程标准价" v-model="selectedCourse.consumePrice" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="12" class="mt-n6">
							<v-checkbox v-model="update.updateStudentPrice" label="是否修改班级学员的课时单价为新课程的标准价" color="red" value="1" hide-details></v-checkbox>    
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitUpdate" :disabled="update.submitting" :loading="update.submitting" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"class-upgrade",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			classModel:{
				type:Object,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					this.update.courseId ="";
					this.selectedCourse = null;
					this.update.updateStudentPrice = "1";
					this.classViewModel = this.classModel;
					this.getCourseListForSelect();
				}
			}
		},
		data(){
			return {
				shopId:"",
				selectCourseList:[],
				hideShow:this.show,
				classViewModel:null,
				selectedCourse:null,
				update:{
					submitting:false,
					courseId:"",
					updateStudentPrice:"1"
				}
			}
		},
		mounted() {
			console.log("class-upgrade mounted");
			this.shopId = utils.getCurrentShopId();
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			},
			submitUpdate(){
				if(!this.update.courseId){
					this.$noty.error("请选择新课程");
					return
				}
				this.update.submitting = true;
				// 是否修改学员价格
				let isUpdate = "0";
				if(this.update.updateStudentPrice == "1"){
					isUpdate = "1"
				}
				
				let postData = {
					classId:this.classModel.id,
					courseId:this.update.courseId,
					updateStudentPrice:isUpdate
				}
				// api
				const that = this;
				let url = `/edu/class/upgrade`;
					
				this.axios.post(url, postData).catch(() => {
					that.update.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							that.update.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.update.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.update.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
				
				
				
			},
			courseChanged(e){
				this.selectedCourse = e;
				this.update.courseId = e.id;
			},
			getCourseListForSelect() {
				if (!this.shopId) {
					return
				}
				const that = this;
				let url = `/edu/shop/course/list/` + this.shopId;
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						
						const list = response.data["data"] ? response.data["data"] : [];
						list.forEach((item,index)=>{
							if (item.consumeType == '2' && item.id != that.classViewModel.courseId){
								that.selectCourseList.push(item);
							}
						})
						
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			
		}
	}
	
</script>

<style>
</style>
